/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {Box, Button, useMultiStyleConfig, VisuallyHidden} from '@chakra-ui/react'
import useZipCodeFields from './useZipCodeFields'
import Field from '../../components/field/index'

const ZipCodeFields = ({form, prefix = '', ...props}) => {
    const fields = useZipCodeFields({form, prefix})
    const style = useMultiStyleConfig('OrderSummary', {})
    const {zipCode} = style
    const code = form.watch('code')
    const {formatMessage} = useIntl()
    const ariaZipLabel = formatMessage({
        defaultMessage: 'Zip Code',
        id: 'use_zip_code_zipcode.label.zip_code',
    })

    return (
        <Box {...style.zipCode?.zipInputContainer} aria-labelledby="code-feedback" {...props}>
            <VisuallyHidden as="label" htmlFor="code">
                {ariaZipLabel}
            </VisuallyHidden>
            <Field
                inputProps={{
                    ...(zipCode?.zipCodeInput || {}),
                    'aria-label': ariaZipLabel,
                }}
                {...fields.code}
                shouldDisplaySuccess={false}
            >
                <Button
                    type="submit"
                    {...style.promoCode?.applyButton}
                    isLoading={form.formState.isSubmitting}
                    disabled={code?.length < 3}
                >
                    <FormattedMessage defaultMessage="Apply" id="zip_code_fields.button.apply" />
                </Button>
            </Field>
        </Box>
    )
}

ZipCodeFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string,
}

export default ZipCodeFields
